import { Box, Button, Flex, Text, useColorModeValue, Link } from '@chakra-ui/react';
import { getLessonStatusBadge } from '../../components/BadgeStatus';
import { getDateAndTimeInterval, getFormattedDate } from '../../components/Format';
import { APPROVAL_FLG } from '../../configs';
import { routeJoinLessonPreview } from '../../helper/route-helper';

export default function LessonInfo({
  lesson,
  onOpenModal,
  lessonNotFinished,
  onCheckFeedBackExist,
  disable,
  isNoAttendees,
}: any) {
  const ItemVal = ({ header, val }: any) => {
    return (
      <Box mb={3}>
        <Flex direction={'column'} mb={2}>
          <Text
            fontWeight="bold"
            fontSize={'xl'}
            mb={{ base: 0, md: 1 }}
            flex={{ base: '1 1 auto', md: 'none' }}
          >
            {header}
          </Text>
          <Text
            fontSize={'xl'}
            fontWeight={'thin'}
            flex={{ base: '1 1 auto', md: 'none' }}
            textAlign={'left'}
            whiteSpace={'pre-wrap'}
          >
            {val}
          </Text>
        </Flex>
      </Box>
    );
  };

  const isDeleted = lesson?.delete_flg || false;

  const LessonDetails = () => {
    return (
      <Box
        width={'100%'}
        height={'100%'}
        p={'6'}
        border={'1px solid #ddd'}
        borderColor={useColorModeValue('#ddd', '#ddd')}
        rounded={'md'}
        className="Learner-Stat"
      >
        <ItemVal header="ステータス" val={getLessonStatusBadge(lesson)} />

        <Flex alignItems="center" gap={4} my={4}>
          <Box>
            <Button
              colorScheme="teal"
              minWidth={'200px'}
              onClick={() => onOpenModal('approvalLessonModal', lesson)}
              disabled={lesson?.approval_flg == APPROVAL_FLG.APPROVED || isDeleted}
            >
              レッスン承認
            </Button>
          </Box>
          <Box>
            <Button
              colorScheme="teal"
              minWidth={'200px'}
              disabled={lessonNotFinished || isDeleted}
              onClick={() => onOpenModal('themeModal', lesson)}
            >
              レッスンテーマ登録
            </Button>
          </Box>
        </Flex>

        <ItemVal
          header="実施日時"
          val={`${getDateAndTimeInterval(lesson?.start_datetime, lesson?.end_datetime)}`}
        />
        <ItemVal header="企業名" val={lesson?.m_company.company_name} />
        <Flex direction={'column'} gap={2}>
          <Box>
            <Link
              href={routeJoinLessonPreview(lesson?.company_id, lesson?.room_id).path}
              isExternal
              style={{ textDecoration: 'none' }}
            >
              <Button
                colorScheme="teal"
                size="lg"
                minWidth={'200px'}
                disabled={!lesson || disable || isNoAttendees || isDeleted}
              >
                入室
              </Button>
            </Link>
          </Box>
          <Text fontSize={'sm'} pl={2}>
            開始5分前から入室可能
          </Text>
        </Flex>
      </Box>
    );
  };

  const LessonAction = () => {
    return (
      <Box
        width={'100%'}
        height={'100%'}
        pt={'6'}
        px={'6'}
        border={'1px solid #ddd'}
        borderColor={useColorModeValue('#ddd', '#ddd')}
        rounded={'md'}
        className="Learner-Stat"
      >
        <Text
          fontWeight="bold"
          fontSize={'xl'}
          mb={{ base: 0, md: 1 }}
          flex={{ base: '1 1 auto', md: 'none' }}
        >
          レッスン後操作
        </Text>

        <Flex alignItems="center" gap={4}>
          {/* <Box>
            <Button
              colorScheme="teal"
              onClick={() => onOpenModal('noteModal', lesson)}
              disabled={lessonNotFinished}
              minWidth={'220px'}
              size="md"
            >
              申し送り登録
            </Button>
          </Box> */}
        </Flex>

        <Flex py={4} alignItems="center">
          <Box>
            <Button
              colorScheme="teal"
              onClick={() => onCheckFeedBackExist()}
              disabled={lessonNotFinished || isDeleted}
              minWidth={'220px'}
              size="md"
            >
              フィードバック一括登録
            </Button>
          </Box>
        </Flex>

        <Flex py={4}>
          <Text fontSize={'md'} color={'gray.700'}>
            レッスン終了後、フィードバックの登録をお願いします。
            <br />
            フィードバックを個別登録する場合は、ページ下部の学習者一覧から登録可能です。
          </Text>
        </Flex>
      </Box>
    );
  };

  return (
    <Flex justifyContent="space-between" gap={8} align="stretch">
      <Flex flex={1} alignItems={'flex-start'} direction="column">
        <LessonDetails />
      </Flex>
      <Flex flex={1} alignItems={'flex-start'} direction="column">
        <LessonAction />
      </Flex>
    </Flex>
  );
}
